/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import { introspectCall } from '../actions/auth.action'
import localStorageService from '../api/localStorageService'
import { ROUTES } from '../helpers/constants'
import { get, getSchoolUrl } from '../helpers/utils'

/**
 * Defines a component EditTemplate
 * @returns {*}
 * @constructor
 */
function withStudentDetailHOC(WrappedComponent) {
  function WrappedEnhanced(props) {
    useEffect(() => {
      props.introspectCall(
        (introspect) => {
          if (get(introspect, 'attributes.is_student[0]', '') !== 'true') {
            const params = localStorageService.getDistrictSchool()
            location.href = getSchoolUrl({ ...params, to: ROUTES.DASHBOARD })
          }
        },
        null,
        { getSMSSettings: false, showLoader: false }
      )
    }, [])
    return <WrappedComponent {...props} />
  }
  WrappedEnhanced.propTypes = {
    introspectCall: PropTypes.func,
  }

  const mapStateToProps = () => ({})
  return connect(mapStateToProps, { introspectCall })(WrappedEnhanced)
}

export default withStudentDetailHOC
